<template>
    <div>
        <div class='choose-good'>
            <div class='row-title' v-if="title" :style="'color:'+styles.color+';font-size:'+styles.font_size+'px'+';font-weight:'+styles.font_weight">{{title}}</div>

            <div class="row-body">
                <div class='coms-goods flex-start' v-for="(goods,index) in content" >
                    <img v-if="!goods.url.pic_url" style="width:100%;" src="https://api-xiangyou.dierqudao.com/public/images/no-pic.png" alt="" srcset="">
                    <img  class='coms-left' v-else :src='goods.url.pic_url'>
            <div class='coms-right'>
                <div class='coms-good-name'>{{goods.url.title}}</div>
                <div class='coms-good-detail flex-between'>
                    <div class='flex-start'>
                        <div class='good-normal-price'>
                            <span>¥</span>100
                        </div>
                        <div class='good-thr-price'>
                            <span>¥</span>200
                        </div>
                    </div>
                    <div class='coms-sell-num'>已售 999</div>
                </div>
                <div class='good-pri-earn' style="margin:4px 0 4px 0 "  v-if="goods.url.max_seller_reward>0">
                    分享可赚￥10
                </div>
                <!-- <div class='coms-tips' v-if="goods.goods.discount_tags.length>0">
                    <div class='coms-tips-one flex-start' v-for="(tag, index) in goods.goods.discount_tags">
                        <div class='coms-tips-type coms-tips-typeq' :style="'background:'+tag.color" v-html="tag.title">{{tag.tag}}</div>{{tag.title}}
                    </div>
                </div> -->
            </div>
        </div>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "GoodsList1",
        components: {
        },
        props: {
            content: {
                type: Array,
                default: [],
            },
            title: {
                type: String,
                default: '',
            },
            styles:{
                type:Object,
                default:''
            }

        },

        data: function () {
            return {}
        },

        methods: {
            goGoodsDetail(url, id) {
                this.$router.push({
                    path: '/' + url,
                    query: {
                        id: id
                    }
                })
            }
        },

        filters: {}

    };
</script>

<style scoped>
.flex-start{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.flex-between{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.flex-end{
	display: flex;
	justify-content: space-end;
	align-items: center;
}
.flex-center{
	display: flex;
	justify-content: center;
	align-items: center;
}
.coms-goods {
        padding: 0 10px 10px;
        align-items: flex-start;
    }

    .coms-left {
        width: 100px;
        height: 100px;
        border-radius: 5px;
    }

    .coms-good-name {
        color: #333;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .coms-right {
        margin-left: 10px;
        width: 240px;
    }

    .coms-sell-num {
        color: #999;
        font-size: 12px;
    }

    .coms-tips {
        border-top: 1px solid #efefef;
        font-size: 12px;
        color: #666666;
    }

    .coms-tips-type {
        width: 14px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        border-radius: 2px;
        color: #fff;
        margin-right: 2.5px;
    }
    .coms-tips-one{
        margin-top: 5px;
    }
    .coms-tips-one text{
        color: #FD2840;
    }
    .coms-tips-typek{
        background: #273040
    }
    .coms-tips-typej{
        background: #42BD56
    }
    .coms-tips-typet{
        background: #FF7500
    }
    .coms-tips-typeq{
        background: #FF5A5F
    }
    .good-normal-price {
        color: #fd2840;
        font-size: 17px;
        font-weight: 500;
    }

    .good-normal-price text {
        font-size: 12px;
    }

    .good-thr-price {
        color: #999;
        font-size: 12px;
        margin-left: 7.5px;
        text-decoration: line-through;
    }

    .good-pri-earn {
        width: auto;
        padding: 2px 2px;
        background: rgba(253, 232, 234, 1);
        border-radius: 2px;
        /* border:2rpx solid rgba(253,40,64,1); */
        font-size: 12px;
        color: #FD2840;
        text-align: center;
        margin-left: 7.5px;
    }
    .choose-good {
        background: #fff;
        clear: both;
    }

    .row-title {
        padding: 10px 15px;
        font-size: 13px;
    }
</style>
